import { combineReducers } from "redux";
import posts from "./posts"

/**
 * This actually says
 * export default combineReducers({
 *  posts : posts,
 * });
 */
export default combineReducers({ posts });